import { Card, Table } from "antd";
import React from "react";
import { alertsColumn } from "../../DummyAPI/TableData/Columns";
import { alertsPageRows } from "../../DummyAPI/TableData/Datasource";
import Filterbox from "../../ui/FilterBox/Filterbox";
import SapaHeader from "../../ui/Header/Header";

const Alerts = () => {
  // adding classname to odd table rows
  const rowClassName = (record, index) => {
    return index % 2 === 1 ? "odd-row" : "";
  };

  const tableStyle = {
    tableLayout: "fixed",
  };

  return (
    <div className="Alerts">
      <SapaHeader page={"Alerts"} />
      <Card className="sapa-alerts__container">
        <Filterbox showRefresh={true} displayFilter={"none"} />
        <Table
          dataSource={alertsPageRows}
          columns={alertsColumn}
          pagination={false}
          rowKey={(record, index) => record?.id ?? record?.key ?? index}
          rowClassName={rowClassName}
          scroll={{ x: 760 }}
          style={tableStyle}
        />
      </Card>
    </div>
  );
};

export default Alerts;
